import React from 'react';

// Official Letterboxd three-dot mark (orange / green / blue)
const LetterboxdIcon = ({ size = 18, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 500 333"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="145" cy="166" r="92" fill="#FF8000" />
    <circle cx="355" cy="166" r="92" fill="#40BCF4" />
    <circle cx="250" cy="166" r="92" fill="#00E054" />
  </svg>
);

export default LetterboxdIcon;
